import { AppConfiguration } from './components/@types/AppConfiguration';
import messages from './locales/messages';

const configuration: AppConfiguration = {
  card: {
    title: messages['cardTitle'].defaultMessage,
    description: messages['cardDescription'].defaultMessage,
    selectedLegendTypes: [],
    onUpdate: (value: string[]) => {
      console.log('Unbound onUpdate from Map Legend', value);
    },
    legends: [],
  },
  legends: [
    {
      title: messages['dataCenter'].defaultMessage,
      type: 'data-centers',
      color: 'blue',
    },
    {
      title: messages['federalDataCenter'].defaultMessage,
      type: 'federal-data-center',
      color: 'magenta',
    },
    {
      title: messages['multiZone'].defaultMessage,
      type: 'multi-zone-region',
      color: 'teal',
    },
    {
      title: messages['networkPoP'].defaultMessage,
      type: 'network-pop',
      color: 'purple',
    },
  ],
  groups: [
    {
      card: {
        title: 'Washington, DC',
        description: '',
      },
      country: 'US',
      city: 'Washington, DC',
      location: {
        x: 1443,
        y: 813,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'WDC02',
        },
        {
          type: 'federal-data-center',
          siteCode: 'WDC03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'WDC04',
        },
        {
          type: 'network-pop',
          siteCode: 'WDC05',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'WDC06',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'WDC07',
        },
      ],
      links: ['Atlanta', 'Chicago', 'New York', 'Amsterdam', 'Madrid'],
    },
    {
      card: {
        title: 'Dallas, TX',
        description: '',
      },
      country: 'US',
      city: 'Dallas',
      location: {
        x: 1065,
        y: 942,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'DAL03',
        },
        {
          type: 'network-pop',
          siteCode: 'DAL04',
        },
        {
          type: 'federal-data-center',
          siteCode: 'DAL08',
        },
        {
          type: 'data-centers',
          siteCode: 'DAL09',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'DAL10',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'DAL12',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'DAL13',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'DAL14',
        },
      ],
      links: [
        'Atlanta',
        'Chicago',
        'Denver',
        'Los Angeles',
        'Querétaro',
        'Miami',
      ],
    },
    {
      card: {
        title: 'San Jose, CA',
        description: '',
      },
      country: 'US',
      city: 'San Jose',
      location: {
        x: 655,
        y: 780,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'SJC02',
        },
        {
          type: 'data-centers',
          siteCode: 'SJC03',
        },
        {
          type: 'data-centers',
          siteCode: 'SJC04',
        },
      ],
      links: ['Los Angeles', 'Seattle', 'Denver', 'Tokyo'],
    },
    {
      card: {
        title: 'Los Angeles, CA',
        description: '',
      },
      country: 'US',
      city: 'Los Angeles',
      location: {
        x: 699,
        y: 870,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'LAX01',
        },
      ],
      links: [
        'Dallas',
        'Denver',
        'Querétaro',
        'San Jose',
        'Sydney',
        'Hong Kong',
        'Seattle',
        'Singapore',
      ],
    },
    {
      card: {
        title: 'Seattle, WA',
        description: '',
      },
      country: 'US',
      city: 'Seattle',
      location: {
        x: 714,
        y: 497,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'SEA02',
        },
      ],
      links: ['Chicago', 'Denver', 'San Jose'],
    },
    {
      card: {
        title: 'Denver, CO',
        description: '',
      },
      country: 'US',
      city: 'Denver',
      location: {
        x: 923,
        y: 825,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'DEN01',
        },
      ],
      links: ['Seattle', 'San Jose', 'Dallas', 'Chicago', 'Los Angeles'],
    },
    {
      card: {
        title: 'Chicago, IL',
        description: '',
      },
      country: 'US',
      city: 'Chicago',
      location: {
        x: 1271,
        y: 721,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'CHI01',
        },
      ],
      links: ['Toronto', 'Ashburn', 'New York', 'Dallas', 'Denver', 'Seattle'],
    },
    {
      card: {
        title: 'Atlanta, GA',
        description: '',
      },
      country: 'US',
      city: 'Atlanta',
      location: {
        x: 1303,
        y: 890,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'ATL01',
        },
      ],
      links: ['Ashburn', 'Dallas', 'Miami'],
    },
    {
      card: {
        title: 'New York City, NY',
        description: '',
      },
      country: 'US',
      city: 'New York City',
      location: {
        x: 1503,
        y: 763,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'NYC01',
        },
        {
          type: 'network-pop',
          siteCode: 'NYC02',
        },
        {
          type: 'network-pop',
          siteCode: 'NYC03',
        },
      ],
      links: ['Ashburn', 'Chicago', 'Montreal', 'London', 'Sao Paulo'],
    },
    {
      card: {
        title: 'Miami, FL',
        description: '',
      },
      country: 'US',
      city: 'Miami',
      location: {
        x: 1357,
        y: 1052,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'MIA01',
        },
      ],
      links: ['Atlanta', 'Dallas', 'Sao Paulo'],
    },
    {
      card: {
        title: 'Toronto',
        description: '',
      },
      country: 'CA',
      city: 'Toronto',
      location: {
        x: 1426,
        y: 681,
      },
      types: [],
      entries: [
        {
          type: 'multi-zone-region',
          siteCode: 'TOR01',
        },
        {
          type: 'network-pop',
          siteCode: 'TOR02',
        },
        {
          type: 'network-pop',
          siteCode: 'TOR03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'TOR04',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'TOR05',
        },
      ],
      links: ['Toronto', 'Ashburn', 'New York', 'Dallas', 'Denver', 'Seattle'],
    },
    {
      card: {
        title: 'Montreal',
        description: '',
      },
      country: 'CA',
      city: 'Montreal',
      location: {
        x: 1536,
        y: 635,
      },
      types: [],
      entries: [
        {
          type: 'data-centers',
          siteCode: 'MON01',
        },
        {
          type: 'network-pop',
          siteCode: 'MON02',
        },
        {
          type: 'network-pop',
          siteCode: 'MON03',
        },
      ],
      links: ['Toronto', 'Ashburn', 'New York', 'Dallas', 'Denver', 'Seattle'],
    },
    {
      card: {
        title: 'Sao Paulo, SP',
        description: '',
      },
      country: 'BR',
      city: 'Sao Paulo',
      location: {
        x: 1982,
        y: 1912,
      },
      types: [],
      entries: [
        {
          type: 'multi-zone-region',
          siteCode: 'SAO01',
        },
        {
          type: 'network-pop',
          siteCode: 'SAO02',
        },
        {
          type: 'network-pop',
          siteCode: 'SAO03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'SAO04',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'SAO05',
        },
      ],
      links: ['New York', 'Miami', 'Ashburn'],
    },
    {
      //europe
      card: {
        title: 'Frankfurt, HE',
        description: '',
      },
      country: 'DE',
      city: 'Frankfurt',
      location: {
        x: 2923,
        y: 592,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'FRA01',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'FRA02',
        },
        {
          type: 'network-pop',
          siteCode: 'FRA03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'FRA04',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'FRA05',
        },
      ],
      links: ['Amsterdam', 'Milan', 'Stockholm', 'Oslo', 'London'],
    },
    {
      card: {
        title: 'Madrid',
        description: '',
      },
      country: 'ES',
      city: 'Madrid',
      location: {
        x: 2714,
        y: 780,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'MAD01',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'MAD02',
        },
        {
          type: 'network-pop',
          siteCode: 'MAD03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'MAD04',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'MAD05',
        },
      ],
      links: ['Paris', 'Ashburn', 'Frankfurt'],
    },
    {
      card: {
        title: 'London',
        description: '',
      },
      country: 'UK',
      city: 'London',
      location: {
        x: 2779,
        y: 551,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'LON01',
        },
        {
          type: 'data-centers',
          siteCode: 'LON02',
        },
        {
          type: 'network-pop',
          siteCode: 'LON03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'LON04',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'LON05',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'LON06',
        },
      ],
      links: ['Amsterdam', 'Paris', 'New York', 'Frankfurt'],
    },
    {
      card: {
        title: 'Oslo',
        description: '',
      },
      country: 'NO',
      city: 'Oslo',
      location: {
        x: 2935,
        y: 356,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'OSL02',
        },
      ],
      links: ['Amsterdam', 'Paris', 'New York', 'Frankfurt'],
    },
    {
      card: {
        title: 'Stockholm',
        description: '',
      },
      country: 'SWE',
      city: 'Stockholm',
      location: {
        x: 3051,
        y: 363,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'STO01',
        },
      ],
      links: ['Amsterdam', 'Paris', 'New York', 'Frankfurt'],
    },
    {
      card: {
        title: 'Paris',
        description: '',
      },
      country: 'FR',
      city: 'Paris',
      location: {
        x: 2832,
        y: 614,
      },
      types: [],
      entries: [
        {
          type: 'data-centers',
          siteCode: 'PAR01',
        },
        {
          type: 'network-pop',
          siteCode: 'PAR02',
        },
        {
          type: 'network-pop',
          siteCode: 'PAR03',
        },
      ],
      links: ['London', 'Milan', 'Chennai'],
    },
    {
      card: {
        title: 'Amsterdam',
        description: '',
      },
      country: 'NL',
      city: 'Amsterdam',
      location: {
        x: 2847,
        y: 556,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'AMS02',
        },
        {
          type: 'data-centers',
          siteCode: 'AMS03',
        },
      ],
      links: ['London', 'Frankfurt', 'Stockholm', 'Paris', 'Ashburn'],
    },
    {
      card: {
        title: 'Milan',
        description: '',
      },
      country: 'IT',
      city: 'Milan',
      location: {
        x: 2926,
        y: 685,
      },
      types: [],
      entries: [
        {
          type: 'data-centers',
          siteCode: 'MIL01',
        },
        {
          type: 'network-pop',
          siteCode: 'MIL02',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Tokyo',
        description: '',
      },
      country: 'JP',
      city: 'Tokyo',
      location: {
        x: 5243,
        y: 808,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'TOK01',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'TOK02',
        },
        {
          type: 'network-pop',
          siteCode: 'TOK03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'TOK04',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'TOK05',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Osaka',
        description: '',
      },
      country: 'JP',
      city: 'Osaka',
      location: {
        x: 5177,
        y: 832,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'OSA01',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'OSA21',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'OSA22',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'OSA23',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Hong Kong',
        description: '',
      },
      country: 'GCG',
      city: 'Hong Kong',
      location: {
        x: 4848,
        y: 1116,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'HKG01',
        },
        {
          type: 'network-pop',
          siteCode: 'HKG03',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Taipei',
        description: '',
      },
      country: 'TW',
      city: 'Taipei',
      location: {
        x: 4971,
        y: 1054,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'TPE01',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Seoul',
        description: '',
      },
      country: 'KR',
      city: 'Seoul',
      location: {
        x: 5014,
        y: 786,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'SE002',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Singapore',
        description: '',
      },
      country: 'SG',
      city: 'Singapore',
      location: {
        x: 4672,
        y: 1484,
      },
      types: [],
      entries: [
        {
          type: 'data-centers',
          siteCode: 'SNG01',
        },
        {
          type: 'network-pop',
          siteCode: 'SNG02',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Chennai',
        description: '',
      },
      country: 'IN',
      city: 'Chennai',
      location: {
        x: 4241,
        y: 1290,
      },
      types: [],
      entries: [
        {
          type: 'data-centers',
          siteCode: 'CHE01',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Mumbai',
        description: '',
      },
      country: 'IN',
      city: 'Mumbai',
      location: {
        x: 4100,
        y: 1184,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'MUM01',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Sydney',
        description: '',
      },
      country: 'AU',
      city: 'Sydney',
      location: {
        x: 5470,
        y: 2166,
      },
      types: [],
      entries: [
        {
          type: 'multi-zone-region',
          siteCode: 'SYD01',
        },
        {
          type: 'network-pop',
          siteCode: 'SYD02',
        },
        {
          type: 'network-pop',
          siteCode: 'SYD03',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'SYD04',
        },
        {
          type: 'multi-zone-region',
          siteCode: 'SYD05',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Melbourne',
        description: '',
      },
      country: 'AU',
      city: 'Melbourne',
      location: {
        x: 5326,
        y: 2259,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'MEL02',
        },
      ],
      links: [],
    },
    {
      card: {
        title: 'Perth',
        description: '',
      },
      country: 'AU',
      city: 'Perth',
      location: {
        x: 4842,
        y: 2079,
      },
      types: [],
      entries: [
        {
          type: 'network-pop',
          siteCode: 'PER01',
        },
      ],
      links: [],
    },
  ],
};

configuration.groups = configuration.groups.map((group) => {
  group?.entries?.forEach((entry) => {
    group.types.push(entry.type);
  });
  return group;
});

export default configuration;
